import React from "react";

// Colorful, lightly illustrative sidebar icons. Each entry is filled artwork
// drawn on a 48x48 grid (its own colours, not currentColor) so it reads like a
// small app icon rather than a flat glyph. Hand-drawn to avoid adding an
// icon-library dependency to the CRA build.
const ICONS = {
  home: (
    <>
      <path d="M24 8 42 22H6z" fill="#1f9a5c" />
      <path d="M24 8 33 15H15z" fill="#26b46c" />
      <rect x="11" y="20" width="26" height="20" rx="2.5" fill="#fdeecb" />
      <rect x="20" y="29" width="8" height="11" rx="1.5" fill="#0f6e56" />
      <rect x="14" y="24" width="6" height="5" rx="1" fill="#37c17d" />
      <rect x="28" y="24" width="6" height="5" rx="1" fill="#37c17d" />
    </>
  ),
  // Captain / take order — a handheld tablet with a pen.
  tablet: (
    <>
      <rect x="9" y="7" width="30" height="34" rx="4" fill="#34404f" />
      <rect x="12" y="10" width="24" height="25" rx="2" fill="#3f8cff" />
      <rect x="15" y="14" width="14" height="2.4" rx="1.2" fill="#fff" opacity="0.95" />
      <rect x="15" y="19" width="18" height="2.4" rx="1.2" fill="#fff" opacity="0.7" />
      <rect x="15" y="24" width="11" height="2.4" rx="1.2" fill="#fff" opacity="0.7" />
      <circle cx="24" cy="38" r="1.7" fill="#8595a8" />
      <path d="M29.5 30.5 34 26l3 3-4.5 4.5-3.6.7z" fill="#f5a623" />
    </>
  ),
  // Open tabs — a printed receipt.
  receipt: (
    <>
      <path d="M13 6h22v33l-3.1-2-3 2-3-2-3 2-3-2-3.9 2z" fill="#fff" stroke="#cdd7de" strokeWidth="1" />
      <rect x="17" y="12" width="14" height="2.8" rx="1.4" fill="#0f6e56" />
      <rect x="17" y="18" width="14" height="2.4" rx="1.2" fill="#a9b8c4" />
      <rect x="17" y="23" width="10" height="2.4" rx="1.2" fill="#a9b8c4" />
      <rect x="17" y="29" width="14" height="3.2" rx="1.6" fill="#f5a623" />
    </>
  ),
  // Cashier — a banknote plus a coin.
  cash: (
    <>
      <rect x="6" y="14" width="29" height="18" rx="3" fill="#2fae74" />
      <rect x="6" y="14" width="29" height="6" rx="3" fill="#37c17d" />
      <circle cx="20" cy="24" r="5" fill="#eafaf1" />
      <circle cx="20" cy="24" r="2.2" fill="#1f9a5c" />
      <circle cx="34" cy="31" r="8" fill="#f5c542" stroke="#e0a91f" strokeWidth="1.5" />
      <path d="M34 27v8M31.6 29.4h4.2M31.4 32.6h4.4" stroke="#8a6d12" strokeWidth="1.6" fill="none" strokeLinecap="round" />
    </>
  ),
  users: (
    <>
      <circle cx="18" cy="17" r="6" fill="#3f8cff" />
      <path d="M7 37c0-6.5 5-10 11-10s11 3.5 11 10z" fill="#3f8cff" />
      <circle cx="32" cy="19" r="5" fill="#f5a623" />
      <path d="M25 37c0-5.5 4-8.5 7-8.5 4.5 0 9 3 9 8.5z" fill="#f5a623" />
    </>
  ),
  // Kitchen — a chef's hat.
  chef: (
    <>
      <path d="M14 26h20v9a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2z" fill="#eef1f4" />
      <path d="M14 27a6 6 0 0 1-1.6-11.7A5.5 5.5 0 0 1 24 12a5.5 5.5 0 0 1 11.6 3.3A6 6 0 0 1 34 27z" fill="#fff" stroke="#dbe1e7" strokeWidth="1" />
      <rect x="14" y="30" width="20" height="3.4" fill="#f5a623" />
    </>
  ),
  // Ready to run — a service bell.
  bell: (
    <>
      <path d="M9 32a15 15 0 0 1 30 0z" fill="#f5c542" />
      <rect x="7" y="31.5" width="34" height="3.6" rx="1.8" fill="#e0a91f" />
      <rect x="22" y="9" width="4" height="5" rx="2" fill="#e0a91f" />
      <path d="M20.5 37a3.5 3.5 0 0 0 7 0z" fill="#e0a91f" />
    </>
  ),
  key: (
    <>
      <circle cx="14" cy="24" r="8" fill="#f5c542" />
      <circle cx="14" cy="24" r="3.2" fill="#063b48" />
      <rect x="21" y="21.8" width="19" height="4.4" rx="2.2" fill="#f5c542" />
      <rect x="31" y="26" width="3.6" height="6" rx="1.5" fill="#f5c542" />
      <rect x="37" y="26" width="3.6" height="5" rx="1.5" fill="#f5c542" />
    </>
  ),
  // Menu — an open book.
  book: (
    <>
      <path d="M24 12c-3-2-7-2.5-11-2v22c4-.5 8 0 11 2z" fill="#ff9d6b" />
      <path d="M24 12c3-2 7-2.5 11-2v22c-4-.5-8 0-11 2z" fill="#ff7a45" />
      <path d="M24 12v24" stroke="#c9421f" strokeWidth="1.6" />
      <path d="M16 16h5M16 20h5M27 16h5M27 20h5" stroke="#fff" strokeWidth="1.4" opacity="0.85" />
    </>
  ),
  sparkles: (
    <>
      <path d="M22 6l3 9 9 3-9 3-3 9-3-9-9-3 9-3z" fill="#f5c542" />
      <path d="M35 27l1.5 4 4 1.5-4 1.5-1.5 4-1.5-4-4-1.5 4-1.5z" fill="#8a7bd8" />
    </>
  ),
  // Buffet — knife and fork over a plate ring.
  utensils: (
    <>
      <circle cx="24" cy="24" r="16" fill="none" stroke="#22a37e" strokeWidth="2.5" opacity="0.55" />
      <path d="M15 9v8a2.5 2.5 0 0 0 5 0V9" fill="none" stroke="#6b7b8c" strokeWidth="3" strokeLinecap="round" />
      <line x1="17.5" y1="17" x2="17.5" y2="39" stroke="#6b7b8c" strokeWidth="3" strokeLinecap="round" />
      <path d="M32 9c-2.5 0-4 3-4 7s1.8 6 4 6" fill="none" stroke="#6b7b8c" strokeWidth="3" strokeLinecap="round" />
      <line x1="32" y1="21" x2="32" y2="39" stroke="#6b7b8c" strokeWidth="3" strokeLinecap="round" />
    </>
  ),
  // Tables & rooms — a floor plan of coloured table tops.
  grid: (
    <>
      <rect x="7" y="7" width="14" height="14" rx="3.5" fill="#22a37e" />
      <rect x="27" y="7" width="14" height="14" rx="3.5" fill="#3f8cff" />
      <rect x="7" y="27" width="14" height="14" rx="3.5" fill="#f5a623" />
      <rect x="27" y="27" width="14" height="14" rx="3.5" fill="#8a7bd8" />
    </>
  ),
  qr: (
    <>
      <rect x="8" y="8" width="32" height="32" rx="6" fill="#fff" />
      <rect x="12" y="12" width="9" height="9" rx="2" fill="#0f6e56" />
      <rect x="27" y="12" width="9" height="9" rx="2" fill="#063b48" />
      <rect x="12" y="27" width="9" height="9" rx="2" fill="#063b48" />
      <rect x="27" y="27" width="4" height="4" fill="#063b48" />
      <rect x="33" y="27" width="3" height="3" fill="#063b48" />
      <rect x="27" y="33" width="3" height="3" fill="#063b48" />
      <rect x="32.5" y="32.5" width="3.5" height="3.5" fill="#0f6e56" />
    </>
  ),
  user: (
    <>
      <circle cx="24" cy="17" r="8" fill="#5b8def" />
      <path d="M9 39c0-8 6.5-12 15-12s15 4 15 12z" fill="#5b8def" />
    </>
  ),
  "user-check": (
    <>
      <circle cx="19" cy="16" r="7.5" fill="#5b8def" />
      <path d="M7 39c0-7.5 5.5-11 12-11s12 3.5 12 11z" fill="#5b8def" />
      <circle cx="34" cy="33" r="8" fill="#2fae74" />
      <path d="M30.5 33l2.5 2.5 4.5-5" stroke="#fff" strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  calendar: (
    <>
      <rect x="8" y="9" width="32" height="30" rx="4" fill="#fff" />
      <rect x="8" y="9" width="32" height="10" rx="4" fill="#e8492b" />
      <rect x="8" y="15" width="32" height="4" fill="#e8492b" />
      <rect x="14" y="6" width="3.5" height="7" rx="1.75" fill="#b7351c" />
      <rect x="30.5" y="6" width="3.5" height="7" rx="1.75" fill="#b7351c" />
      <rect x="13" y="23" width="6" height="5" rx="1" fill="#5b8def" />
      <rect x="21" y="23" width="6" height="5" rx="1" fill="#e2e8ee" />
      <rect x="29" y="23" width="6" height="5" rx="1" fill="#e2e8ee" />
      <rect x="13" y="30" width="6" height="5" rx="1" fill="#e2e8ee" />
      <rect x="21" y="30" width="6" height="5" rx="1" fill="#f5a623" />
    </>
  ),
  "bar-chart": (
    <>
      <rect x="9" y="26" width="7.5" height="13" rx="1.8" fill="#22a37e" />
      <rect x="20.2" y="16" width="7.5" height="23" rx="1.8" fill="#3f8cff" />
      <rect x="31.5" y="21" width="7.5" height="18" rx="1.8" fill="#f5a623" />
    </>
  ),
  // End of day (Z report) — a document.
  "file-text": (
    <>
      <path d="M12 6h16l8 8v26a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" fill="#fff" stroke="#d5dde3" strokeWidth="1" />
      <path d="M28 6v8h8z" fill="#cfe0dc" />
      <rect x="16" y="20" width="16" height="2.6" rx="1.3" fill="#0f6e56" />
      <rect x="16" y="26" width="16" height="2.4" rx="1.2" fill="#a9b8c4" />
      <rect x="16" y="31" width="11" height="2.4" rx="1.2" fill="#a9b8c4" />
    </>
  ),
  star: (
    <path d="M24 6l5.3 10.7 11.7 1.7-8.5 8.3 2 11.6L24 34.8 13.5 40.6l2-11.6L7 20.7l11.7-1.7z" fill="#f5c542" stroke="#e0a91f" strokeWidth="1" />
  ),
  recycle: (
    <g fill="none" stroke="#37b24d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 14l6-9 6 9" />
      <path d="M30 14l5 3-4 8" />
      <path d="M18 14l-6 3 4 9h9" />
      <path d="M31 25l6-1-2 9h-10" />
      <path d="M25 34l-4-4 4-4" />
    </g>
  ),
  sliders: (
    <>
      <line x1="10" y1="15" x2="38" y2="15" stroke="#7f8fa0" strokeWidth="3" strokeLinecap="round" />
      <circle cx="18" cy="15" r="5" fill="#5b8def" stroke="#fff" strokeWidth="2" />
      <line x1="10" y1="27" x2="38" y2="27" stroke="#7f8fa0" strokeWidth="3" strokeLinecap="round" />
      <circle cx="30" cy="27" r="5" fill="#f5a623" stroke="#fff" strokeWidth="2" />
      <line x1="10" y1="39" x2="38" y2="39" stroke="#7f8fa0" strokeWidth="3" strokeLinecap="round" />
      <circle cx="22" cy="39" r="5" fill="#2fae74" stroke="#fff" strokeWidth="2" />
    </>
  ),
  // Cost overview — a pie chart.
  pie: (
    <>
      <circle cx="24" cy="24" r="16" fill="#22a37e" />
      <path d="M24 24V8a16 16 0 0 1 13.8 8z" fill="#5b8def" />
      <path d="M24 24 37.8 16a16 16 0 0 1-2 18z" fill="#f5a623" />
    </>
  ),
  // Ingredients — a carrot.
  leaf: (
    <>
      <path d="M19 21 11 35a2.4 2.4 0 0 0 3 3l14-8z" fill="#f5852a" />
      <path d="M19 21l9-4-1 5z" fill="#ff9d4d" />
      <path d="M22 18c-1-3-4-4-4-4s0 3 2 4.5M25 16c1-3 4.5-3.5 4.5-3.5s-.5 3-2.5 4" stroke="#2fae74" strokeWidth="2.2" fill="none" strokeLinecap="round" />
    </>
  ),
  // Recipes — a bound recipe book.
  recipe: (
    <>
      <rect x="10" y="7" width="28" height="34" rx="3" fill="#2fae74" />
      <rect x="14" y="7" width="24" height="34" rx="2" fill="#fff" />
      <rect x="10" y="7" width="4.5" height="34" fill="#1f9a5c" />
      <rect x="18" y="14" width="16" height="2.4" rx="1.2" fill="#f5a623" />
      <rect x="18" y="20" width="16" height="2.2" rx="1.1" fill="#c3ccd4" />
      <rect x="18" y="25" width="16" height="2.2" rx="1.1" fill="#c3ccd4" />
      <rect x="18" y="30" width="11" height="2.2" rx="1.1" fill="#c3ccd4" />
    </>
  ),
  // Kitchen issue — stock leaving a box (up arrow).
  "box-out": (
    <>
      <path d="M8 16 24 9l16 7-16 7z" fill="#e8b988" />
      <path d="M8 16v16l16 7V23z" fill="#d9a066" />
      <path d="M40 16v16l-16 7V23z" fill="#c98f52" />
      <path d="M24 32v-9M20 27l4-4 4 4" stroke="#0f6e56" strokeWidth="2.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  // Usage — a flame.
  flame: (
    <>
      <path d="M24 6c2 5 8 8 8 15a8 8 0 0 1-16 0c0-3 1-5 2.2-6.2.4 2 1.8 3.2 3.3 3.2C20 15 22 10 24 6z" fill="#f5852a" />
      <path d="M24 21c1 2.5 3 3.5 3 6a3 3 0 0 1-6 0c0-1.5 1.5-3 3-6z" fill="#f5c542" />
    </>
  ),
  // Variance — a balance scale.
  scale: (
    <>
      <rect x="22.5" y="8" width="3" height="30" rx="1.5" fill="#c9a24a" />
      <rect x="14" y="37" width="20" height="3.2" rx="1.6" fill="#c9a24a" />
      <line x1="9" y1="13" x2="39" y2="13" stroke="#c9a24a" strokeWidth="3" strokeLinecap="round" />
      <circle cx="24" cy="11.5" r="2.6" fill="#f5c542" />
      <path d="M9 13 5 22h8z" fill="#f5c542" />
      <path d="M39 13 35 22h8z" fill="#f5c542" />
    </>
  ),
  // Purchasing — a shopping cart.
  cart: (
    <>
      <path d="M9 10h4.5l3 15h15l3-11H16.5" fill="none" stroke="#3f8cff" strokeWidth="2.6" strokeLinejoin="round" strokeLinecap="round" />
      <rect x="18" y="14" width="12" height="7" rx="1.5" fill="#f5a623" />
      <circle cx="18" cy="34" r="2.6" fill="#2b6fd6" />
      <circle cx="30" cy="34" r="2.6" fill="#2b6fd6" />
    </>
  ),
  // Stocktake — a clipboard with a check.
  clipboard: (
    <>
      <rect x="12" y="9" width="24" height="30" rx="3.5" fill="#fff" stroke="#d5dde3" strokeWidth="1" />
      <rect x="18" y="6" width="12" height="6" rx="2" fill="#8a7bd8" />
      <path d="M16.5 24.5 21 29l8.5-9.5" fill="none" stroke="#1f9a5c" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  // Maintenance — a wrench.
  wrench: (
    <>
      <path d="M31.5 8.5a8.5 8.5 0 0 0-9.9 11.2L9 32.3a3.8 3.8 0 0 0 5.4 5.4l12.6-12.6A8.5 8.5 0 0 0 38 15.5l-5.2 5.2-4.5-1.2-1.2-4.5 5.2-5.2a8.5 8.5 0 0 0-.8-1.3Z" fill="#6b7c8f" stroke="#4a5766" strokeWidth="1" strokeLinejoin="round" />
      <circle cx="12" cy="35" r="1.8" fill="#fff" />
    </>
  ),
  settings: (
    <>
      <g fill="#3f6fb0">
        <rect x="21.5" y="4" width="5" height="8" rx="1.5" />
        <rect x="21.5" y="36" width="5" height="8" rx="1.5" />
        <rect x="4" y="21.5" width="8" height="5" rx="1.5" />
        <rect x="36" y="21.5" width="8" height="5" rx="1.5" />
        <rect x="9" y="9" width="5" height="8" rx="1.5" transform="rotate(-45 11.5 13)" />
        <rect x="34" y="9" width="5" height="8" rx="1.5" transform="rotate(45 36.5 13)" />
        <rect x="9" y="31" width="5" height="8" rx="1.5" transform="rotate(45 11.5 35)" />
        <rect x="34" y="31" width="5" height="8" rx="1.5" transform="rotate(-45 36.5 35)" />
      </g>
      <circle cx="24" cy="24" r="11" fill="#5b8def" />
      <circle cx="24" cy="24" r="4.5" fill="#fff" />
    </>
  ),
  building: (
    <>
      <rect x="9" y="10" width="14" height="29" rx="1.5" fill="#3f8cff" />
      <rect x="23" y="16" width="16" height="23" rx="1.5" fill="#5b8def" />
      <g fill="#dbe9ff">
        <rect x="12" y="14" width="3" height="3" />
        <rect x="17" y="14" width="3" height="3" />
        <rect x="12" y="20" width="3" height="3" />
        <rect x="17" y="20" width="3" height="3" />
        <rect x="12" y="26" width="3" height="3" />
        <rect x="17" y="26" width="3" height="3" />
        <rect x="27" y="20" width="3" height="3" />
        <rect x="32" y="20" width="3" height="3" />
        <rect x="27" y="26" width="3" height="3" />
        <rect x="32" y="26" width="3" height="3" />
      </g>
      <rect x="14" y="32" width="4" height="7" fill="#dbe9ff" />
    </>
  ),
  "user-plus": (
    <>
      <circle cx="18" cy="16" r="7.5" fill="#5b8def" />
      <path d="M6 39c0-7.5 5.5-11 12-11s12 3.5 12 11z" fill="#5b8def" />
      <circle cx="35" cy="16" r="7" fill="#2fae74" />
      <path d="M35 12v8M31 16h8" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
    </>
  ),
  clock: (
    <>
      <circle cx="24" cy="24" r="17" fill="#5b8def" />
      <circle cx="24" cy="24" r="17" fill="none" stroke="#3f6fb0" strokeWidth="2" />
      <path d="M24 13v11l7 4" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  // Front desk — rooms.
  bed: (
    <>
      <path d="M5 23V14a2 2 0 0 1 2-2" fill="none" stroke="#3f6fb0" strokeWidth="2.6" strokeLinecap="round" />
      <rect x="5" y="22" width="38" height="9" rx="2" fill="#3f6fb0" />
      <rect x="8" y="15" width="33" height="8" rx="2.5" fill="#5b8def" />
      <rect x="11" y="17" width="9" height="5" rx="2" fill="#eaf1ff" />
      <path d="M6 31v6M42 31v6" stroke="#34404f" strokeWidth="3" strokeLinecap="round" />
    </>
  ),
  // Housekeeping — a broom.
  broom: (
    <>
      <path d="M31 7 19 19" stroke="#8a5a2b" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M20 20 9 31l4 8 12-11z" fill="#f2b84b" />
      <path d="M11 30l4 8M15 27l3.4 8M19 24l3 7" stroke="#c98f2e" strokeWidth="1.4" strokeLinecap="round" />
    </>
  ),
  reception: (
    <>
      <rect x="5" y="20" width="38" height="16" rx="2" fill="#5b8def" />
      <rect x="5" y="20" width="38" height="5" rx="2" fill="#3f6fb0" />
      <rect x="9" y="28" width="7" height="8" fill="#dbe9ff" />
      <circle cx="31" cy="14" r="5" fill="#f5a623" />
      <path d="M23 20c0-4.4 3.6-8 8-8s8 3.6 8 8z" fill="#f5a623" />
    </>
  ),
  // Data protection — a shield with a check.
  shield: (
    <>
      <path d="M24 6l14 5v10c0 9-6 15-14 20-8-5-14-11-14-20V11z" fill="#3f8cff" />
      <path d="M24 6l14 5v10c0 9-6 15-14 20z" fill="#2f6fd0" />
      <path d="M17 24l5 5 9-11" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
};

export function NavIcon({ name, size = 38 }) {
  const art = ICONS[name];
  if (!art) return null;
  return (
    <svg
      className="sidebar-ico"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      {art}
    </svg>
  );
}

export default NavIcon;
